import { render, staticRenderFns } from "./clientInfo.vue?vue&type=template&id=65e58ff7&scoped=true"
import script from "./clientInfo.vue?vue&type=script&lang=js"
export * from "./clientInfo.vue?vue&type=script&lang=js"
import style0 from "./clientInfo.vue?vue&type=style&index=0&id=65e58ff7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e58ff7",
  null
  
)

export default component.exports